export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple
  },
  {
    title: that.$l('INDEX.table_choose_user_username') || '姓名',
    field: 'userName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    title: '工号',
    field: 'userNo',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    field: 'userPost',
    minWidth: 100,
    align: 'left',
    title: that.$l('INDEX.table_choose_user_userJob') || '职务角色',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_choose_user_mobileNumber') || '手机号',
    field: 'mobileNumber',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    field: 'orgName',
    minWidth: 170,
    align: 'left',
    title: that.$l('INDEX.table_choose_user_orgName') || '所属公司',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_choose_user_depName') || '所属部门',
    field: 'depName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  }
]
